/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const DiscountIcon = /*#__PURE__*/ createSvgIcon(
  'DiscountIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.793 1.5H18.5v8.707l-8.5 8.5L1.293 10l8.5-8.5zm.414 1l-7.5 7.5L10 17.293l7.5-7.5V2.5h-7.293z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 10.29H6.38v-1H14v1zM10.19 12.09a.7.7 0 00-.7.7v.01a.7.7 0 00.7.7h.01a.7.7 0 00.7-.7v-.01a.7.7 0 00-.7-.7h-.01zm-1.7.7a1.7 1.7 0 011.7-1.7h.01a1.7 1.7 0 011.7 1.7v.01a1.7 1.7 0 01-1.7 1.7h-.01a1.7 1.7 0 01-1.7-1.7v-.01zM10.19 6.08a.7.7 0 00-.7.7v.01a.7.7 0 00.7.7h.01a.7.7 0 00.7-.7v-.01a.7.7 0 00-.7-.7h-.01zm-1.7.7a1.7 1.7 0 011.7-1.7h.01a1.7 1.7 0 011.7 1.7v.01a1.7 1.7 0 01-1.7 1.7h-.01a1.7 1.7 0 01-1.7-1.7v-.01z"
            fill="currentColor"
          />
          <path
            d="M15.05 5.79a.84.84 0 100-1.68.84.84 0 000 1.68z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default DiscountIcon;
